import React from 'react';
import { ArrowRightIcon, LockIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
const meta = [{
  icon: InfinityIcon,
  label: 'One-time payment · Lifetime access'
}, {
  icon: LockIcon,
  label: '100% secure payment'
}, {
  icon: DownloadIcon,
  label: 'Immediate digital download'
}];
export function PriceOffer() {
  return <div id="offer" className="mx-auto max-w-3xl scroll-mt-8 rounded-2xl border border-brand-gold/30 bg-navy-900 p-6 text-center shadow-2xl sm:p-8" data-id="element-106" data-mp="3jy6vdzxku0cr">
      <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1" data-id="element-107" data-mp="2rakpgl0vmjmq">
        <span className="text-5xl font-black leading-none tracking-tight text-brand-gold sm:text-6xl" style={{
        color: "#FFF200"
      }} data-id="element-108" data-mp="2rcnnnsc6nj2j">
          24  <span className="text-2xl align-top sm:text-3xl" data-id="element-109" data-mp="319a84g0lk841">USD</span>
        </span>
        <span className="text-lg font-semibold text-slate-400 line-through decoration-slate-500 sm:text-xl" data-id="element-110" data-mp="bjyevq8bx00y">
          129 USD
        </span>
      </div>

      <p className="mt-3 text-sm font-semibold text-white" data-id="element-111" data-mp="ggydxh6rh2ik">5 volumes + 5 bonuses included (800+pages)</p>

      <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-112" data-mp="3uavq6ib29ky2">
        {meta.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-1.5 text-[13px] font-medium leading-tight text-slate-300" data-id="element-113" data-mp="3lbs3738rwlea">
            <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-114" data-mp="3gc5kiea6ecy3" />
            {label}
          </li>)}
      </ul>

      <a href="https://the-real-estate-growth-system.impultienda.ar/checkout" className="group mt-6 inline-flex w-full items-center justify-center gap-3 rounded-lg bg-brand-gold px-6 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-navy-900 shadow-cta transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-goldDark hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold active:translate-y-0 sm:w-auto sm:text-base" style={{
      fontSize: "18px",
      fontWeight: "900",
      fontFamily: "Avenir, sans-serif",
      backgroundColor: "#FFF200",
      backgroundImage: "none"
    }} data-id="element-115" data-mp="3bg8bkt18s8vc">
        YES! I WANT THE COMPLETE SYSTEM FOR JUST 24 USD
        <ArrowRightIcon aria-hidden="true" className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" data-id="element-116" data-mp="251aka0m4hrip" />
      </a>

      <p className="mt-3 text-center text-[12px] leading-snug text-slate-400" data-id="element-117" data-mp="2wrounmuxglpm">
        Instant access · 7-day guarantee · Join <span className="font-semibold text-slate-200" data-id="element-118" data-mp="31qrpyfl3vdke">2,000+ agents</span> who&rsquo;ve already transformed their business.
      </p>
    </div>;
}